import { type DetailedHTMLProps, type HTMLAttributes } from "react"

import { cn } from "#app/utils/misc"

const SRCSET_WIDTHS = [200, 400, 600, 800, 1200]

function buildSrcSet(src: string, format: "webp" | "jpeg") {
	return SRCSET_WIDTHS.map(w => `${src}?w=${w}&format=${format} ${w}w`).join(
		", ",
	)
}

export default function BlogImage({
	src,
	alt,
	sizes = "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 800px",
	loading = "lazy",
	decoding = "async",
	className,
	...props
}: {
	alt: string
	src: string
	sizes?: string
	loading?: "lazy" | "eager"
	decoding?: "async" | "sync"
} & DetailedHTMLProps<HTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
	return (
		<picture>
			<source
				type="image/webp"
				srcSet={buildSrcSet(src, "webp")}
				sizes={sizes}
			/>
			<img
				alt={alt}
				src={`${src}?w=1200&format=jpeg`}
				srcSet={buildSrcSet(src, "jpeg")}
				className={cn("h-full w-full object-cover", className)}
				sizes={sizes}
				loading={loading}
				decoding={decoding}
				{...props}
			/>
		</picture>
	)
}
